import { IconCaretLeft, IconCaretRight, IconChevronDown } from '@/components/icons';
import type { CalendarHead } from './UiDatePicker.utils';

type UiDatePickerHeadProps = {
    head: CalendarHead;
    onStep: (focus: string) => void;
    onUp: () => void;
};

/** The two steps and the title between them; the title opens the next coarser view. */
export function UiDatePickerHead({ head, onStep, onUp }: UiDatePickerHeadProps) {
    const { title, up, previous, next } = head;

    return (
        <div className="form-datepicker-head">
            <button
                type="button"
                className="form-datepicker-nav"
                aria-label={previous.label}
                disabled={previous.disabled}
                onClick={() => onStep(previous.focus)}
            >
                <IconCaretLeft className="size-4" aria-hidden="true" />
            </button>

            {up ? (
                <button type="button" className="form-datepicker-title" aria-live="polite" onClick={onUp}>
                    {title}
                    <span className="sr-only">, {up.label}</span>
                    <IconChevronDown className="size-3" aria-hidden="true" />
                </button>
            ) : (
                <span className="form-datepicker-title" aria-live="polite">
                    {title}
                </span>
            )}

            <button
                type="button"
                className="form-datepicker-nav"
                aria-label={next.label}
                disabled={next.disabled}
                onClick={() => onStep(next.focus)}
            >
                <IconCaretRight className="size-4" aria-hidden="true" />
            </button>
        </div>
    );
}
